/// <amd-module name="Search/Code/Flux/Sources/PreferenceSpy" />

import * as BaseActionsHub from "Search/Shared/Base/ActionsHub";
import { ActionsHub } from "Search/Code/Flux/ActionsHub";
import { ISearchLocalSettingsService } from "Search/Shared/Base/LocalSettingsService";
import { CodeResult } from "Search/LegacyWebApi/Contracts/Code";
import { IVssPageContext } from "VSS/Platform/Context";
import { PreferenceConstants } from "Search/Code/Constants";

export class PreferenceSpy {
    private readonly settingsService: ISearchLocalSettingsService;

    constructor(private readonly pageContext: IVssPageContext, private readonly actionsHub: ActionsHub) {
        this.settingsService = this.pageContext.getService<ISearchLocalSettingsService>("ISearchLocalSettingsService");
        this.registerActionsHubHandlers();
    }

    public dispose = (): void => {
        this.disposeActionsHubHandlers();
    }

    private registerActionsHubHandlers = (): void => {
        this.actionsHub.sortOptionChanged.addListener(this.persistSortPerference);
        this.actionsHub.splitterFixedSizeChanged.addListener(this.persistSplitterFixedSize);
        this.actionsHub.previewOrientationChanged.addListener(this.persistPreviewOrientation);
    }

    private disposeActionsHubHandlers = (): void => {
        this.actionsHub.sortOptionChanged.removeListener(this.persistSortPerference);
        this.actionsHub.splitterFixedSizeChanged.removeListener(this.persistSplitterFixedSize);
        this.actionsHub.previewOrientationChanged.removeListener(this.persistPreviewOrientation);
    }

    private persistSortPerference = (payload: BaseActionsHub.ISortOptionChangedPayload<CodeResult>): void => {
        const { sortOption } = payload;

        // defer so that it doesn't block action invokers.
        setTimeout(() => this.settingsService.setValue(PreferenceConstants.SortOptionKey, sortOption), 0);
    }

    private persistSplitterFixedSize = (newFixedSize: number): void => {
        // defer so that it doesn't block action invokers.
        setTimeout(() => this.settingsService.setValue(PreferenceConstants.SplitterFixedSizeKey, newFixedSize), 0);
    }

    private persistPreviewOrientation = ({ previewOrientation }: BaseActionsHub.IPreviewOrientationChangedPayload): void => {
        // defer so that it doesn't block action invokers.
        setTimeout(() => this.settingsService.setValue(PreferenceConstants.PreviewOrientationKey, previewOrientation.key), 0);
    }
}
